module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Router":{"routes.@":[{"value":"#home #home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Router","_fox_":1}],"routes.@miss":[{"value":"#home #404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Router","_fox_":1}],"routes.@join":[{"value":"#join #join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/router.js
// module id = 681
// module chunks = 4